import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  booking,
  booking_active,
  logout_icon,
  master_active,
  master_img,
  mmc_active,
  mmc_img,
  navi_active,
  navi_img,
  navi_review,
  navi_review_active,
  owner_active,
  owner_img,
  profile_img,
  property,
  property_active,
  recp_active,
  recp_img,
  role_active,
  role_img,
  user_act,
  user_icon,
  user_img,
  booked_side_active,
  booked_side,
  dash_act,
  dash_icon,
  chat_icon,
  chat_unselect,
} from "../assets/imgs";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useLazyLogoutQuery } from "../screens/redux/api/api";
import { toast } from "react-toastify";

const ProfileNavBar = ({ setSaidList }) => {
  // RTK Query
  const [logoutApi] = useLazyLogoutQuery();

  const [roles, setRoles] = useState(null);
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [locationlist, setLocationlist] = useState([]);
  const [givenpermissions, setGivenpermissions] = useState([]);
  const [showMasters, setShowMasters] = useState(false);
  const [showBlocked, setShowBlocked] = useState(false);
  const [showPropertyVerification, setShowPropertyVerification] =
    useState(false);
  const [showReviews, setShowReviews] = useState(false);
  const [showSuspended, setShowSuspended] = useState(false);
  const [showBookings, setShowBookings] = useState(false);
  const [showMmc, setShowMmc] = useState(false);
  const [showMmcCancellation, setShowMmcCancellation] = useState(false);

  const rolePermissions = JSON.parse(localStorage.getItem("permissions"));

  // console.log("rolePermissions", rolePermissions);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [popup, setPopup] = useState();
  const [loading, setLoading] = useState(false);

  const logout = () => {
    setLoading(true);
    logoutApi()
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          localStorage.clear();
          setPopup(false);
          navigate("/");
        }
      })
      .catch((err) => {
        console.log("errr", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setGivenpermissions(localStorage.getItem("permission"));
  }, []);

  const camp_drop = () => {
    setRoles(!roles);
  };

  const toggle_nav = () => {
    setSaidBarShow(!saideBarShow);
  };

  const toggleBookings = () => {
    if (!showBookings) {
      navigate("/upcoming"); // Navigate to first sub-link
      setShowMasters(false);
      setShowBlocked(false);
      setShowReviews(false);
      setShowMmc(false);
      setShowMmcCancellation(false);
      setShowPropertyVerification(false);
      setShowSuspended(false);
    }
    setShowBookings(!showBookings);
  };

  const toggleMasters = () => {
    if (!showMasters) {
      navigate("/amenities"); // Navigate to first sub-link
      setShowBookings(false);
      setShowBlocked(false);
      setShowReviews(false);
      setShowMmc(false);
      setShowMmcCancellation(false);
      setShowPropertyVerification(false);
      setShowSuspended(false);
    }
    setShowMasters(!showMasters);
  };

  const toggleBlocked = () => {
    if (!showBlocked) {
      navigate("/property-unblock"); // Navigate to first sub-linkx
      setShowBookings(false);
      setShowReviews(false);
      setShowMasters(false);
      setShowMmc(false);
      setShowMmcCancellation(false);
      setShowPropertyVerification(false);
      setShowSuspended(false);
    }

    setShowBlocked(!showBlocked);
  };

  const toggleReview = () => {
    if (!showReviews) {
      navigate("/user-review"); // Navigate to first sub-link
      setShowBookings(false);
      setShowMasters(false);
      setShowBlocked(false);
      setShowMmc(false);
      setShowMmcCancellation(false);
      setShowPropertyVerification(false);
      setShowSuspended(false);
    }
    setShowReviews(!showReviews);
  };
  const toggleSuspended = () => {
    if (!showSuspended) {
      navigate("/suspended-property"); // Navigate to first sub-link
      setShowBookings(false);
      setShowMasters(false);
      setShowBlocked(false);
      setShowMmc(false);
      setShowMmcCancellation(false);
      setShowPropertyVerification(false);
    }
    setShowSuspended(!showSuspended);
  };

  const togglePropertVerify = () => {
    if (!showPropertyVerification) {
      navigate("/request-property"); // Navigate to first sub-link
      setShowBookings(false);
      setShowMasters(false);
      setShowBlocked(false);
      setShowMmc(false);
      setShowMmcCancellation(false);
      setShowSuspended(false);
    }
    setShowPropertyVerification(!showPropertyVerification);
  };

  const toggleMMC = () => {
    if (!showMmc) {
      navigate("/transaction-list"); // Navigate to first sub-link
      setShowBookings(false);
      setShowMasters(false);
      setShowBlocked(false);
      setShowReviews(false);
      setShowMmcCancellation(false);
      setShowPropertyVerification(false);
      setShowSuspended(false);
    }
    setShowMmc(!showMmc);
  };
  const toggleMmcCancellation = () => {
    if (!showMmcCancellation) {
      navigate("/request"); // Navigate to first sub-link
      setShowBookings(false);
      setShowMasters(false);
      setShowBlocked(false);
      setShowReviews(false);
      setShowMmc(false);
      setShowPropertyVerification(false);
      setShowSuspended(false);
    }
    setShowMmcCancellation(!showMmcCancellation);
  };

  const onClose = () => {
    setShowBookings(false);
    setShowMasters(false);
    setShowBlocked(false);
    setShowReviews(false);
    setShowPropertyVerification(false);
    setShowSuspended(false);
  };

  return (
    <div className={`${saideBarShow ? "sidebar" : "close_sidebar"}`}>
      <div onClick={toggle_nav} className="">
        {saideBarShow ? (
          <KeyboardDoubleArrowRightIcon className="arrow-right" />
        ) : (
          ""
        )}
      </div>
      <div onClick={toggle_nav} className="">
        {saideBarShow ? (
          ""
        ) : (
          <KeyboardDoubleArrowLeftIcon className="arrow-left" />
        )}
      </div>

      <div className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            <li
              className="nav_link trans"
              onClick={() => {
                navigate("/welcome");
                onClose();
              }}
            >
              <h4
                className={`${splitLocation[1] === "welcome" ? "f3 active_bar" : ""
                  } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
              >
                {splitLocation[1] === "welcome" ? (
                  <img src={dash_act} className="icon" alt="" />
                ) : (
                  <img src={dash_icon} className="icon" alt="" />
                )}
                <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                  Welcome
                </span>
              </h4>
            </li>
            {rolePermissions?.includes("CAN-LIST-DASHBOARD") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/dashboard");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "dashboard" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "dashboard" ? (
                    <img src={dash_act} className="icon" alt="" />
                  ) : (
                    <img src={dash_icon} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Dashboard
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-ADMIN") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/admin-list");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "admin-list" ||
                    splitLocation[1] === "admin-add"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "admin-list" ||
                    splitLocation[1] === "admin-add" ? (
                    <img src={user_act} className="icon" alt="" />
                  ) : (
                    <img src={profile_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Admin
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-ROLE") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/role");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "role" ||
                    splitLocation[1] === "add-role"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "role" ||
                    splitLocation[1] === "add-role" ? (
                    <img src={role_active} className="icon" alt="" />
                  ) : (
                    <img src={role_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Role
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-USERS") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/user-list");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "user-list" ||
                    splitLocation[1] === "user-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "user-list" ||
                    splitLocation[1] === "user-view" ? (
                    <img src={user_act} className="icon" alt="" />
                  ) : (
                    <img src={profile_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    User
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-OWNER") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/owner-list");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "owner-list" ||
                    splitLocation[1] === "owner-add" ||
                    splitLocation[1] === "owner-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "owner-list" ||
                    splitLocation[1] === "owner-add" ||
                    splitLocation[1] === "owner-view" ? (
                    <img src={owner_active} className="icon" alt="" />
                  ) : (
                    <img src={owner_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Owners
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-RECEPTIONIST") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/reception");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "reception" ||
                    splitLocation[1] === "recpetion-add" ||
                    splitLocation[1] === "recpetion-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "reception" ||
                    splitLocation[1] === "recpetion-add" ||
                    splitLocation[1] === "recpetion-view" ? (
                    <img src={recp_active} className="icon" alt="" />
                  ) : (
                    <img src={recp_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Receptionist
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-BOOKINGS") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => toggleBookings()}
              >
                <h4
                  className={`${[
                    "upcoming",
                    "completed",
                    "cancelled",
                    "upcoming-view",
                    "upcoming-view",
                    "cancelled-view",
                    "upcoming-list",
                    "cancelled-list",
                    "completed-view",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      [
                        "upcoming",
                        "completed",
                        "cancelled",
                        "upcoming-view",
                        "upcoming-view",
                        "cancelled-view",
                        "upcoming-list",
                        "cancelled-list",
                        "completed-view",
                      ].includes(splitLocation[1])
                        ? booking_active
                        : booking
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"
                  // onMouseEnter={() => setShowBookings(true)}
                  // onMouseLeave={() => setShowBookings(false)}
                  >
                    Bookings <KeyboardArrowDownIcon />
                  </span>
                </h4>
              </li>
            )}

            {/* Bookings Sub-Links */}
            <ul className={`sub-menu ${showBookings ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/upcoming")}
              >
                <h4
                  className={`${splitLocation[1] === "upcoming" ||
                    splitLocation[1] === "upcoming-list" ||
                    splitLocation[1] === "upcoming-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Upcoming
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/completed")}
              >
                <h4
                  className={`${splitLocation[1] === "completed" ||
                    splitLocation[1] === "completed-list" ||
                    splitLocation[1] === "completed-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Completed
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/cancelled")}
              >
                <h4
                  className={`${splitLocation[1] === "cancelled" ||
                    splitLocation[1] === "cancelled-list" ||
                    splitLocation[1] === "cancelled-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Cancelled
                  </span>
                </h4>
              </li>
            </ul>
            {rolePermissions?.includes("CAN-LIST-PROPERTY") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/property");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "property" ||
                    splitLocation[1] === "property-view" ||
                    splitLocation[1] === "property-add"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      splitLocation[1] === "property" ||
                        splitLocation[1] === "property-view" ||
                        splitLocation[1] === "property-add"
                        ? property_active
                        : property
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Property
                  </span>
                </h4>
              </li>
            )}
            {rolePermissions?.includes("CAN-LIST-PROPERTY VERIFICATION") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => togglePropertVerify()}
              >
                <h4
                  className={`${[
                    "request-property",
                    "approved-property",
                    "rejected-property",
                    "property-reverification",
                    "property-reverification-view",
                    "property-req-view",
                    "property-approve-view",
                    "property-rej-view",
                    "property-reverification-view",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      [
                        "request-property",
                        "approved-property",
                        "rejected-property",
                        "property-reverification",
                        "property-reverification-view",
                        "property-req-view",
                        "property-approve-view",
                        "property-rej-view",
                        "property-reverification-view",
                      ].includes(splitLocation[1])
                        ? property_active
                        : property
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"

                  // onMouseEnter={() => setShowMasters(true)}
                  // onMouseLeave={() => setShowMasters(false)}
                  >
                    Property Verification <KeyboardArrowDownIcon />
                  </span>
                </h4>
              </li>
            )}

            {/* Property Verification Sub-Links */}
            <ul
              className={`sub-menu  ${showPropertyVerification ? "show" : ""}`}
            >
              <li
                className="nav_link trans"
                onClick={() => navigate("/request-property")}
              >
                <h4
                  className={`${splitLocation[1] === "request-property" ||
                    splitLocation[1] === "property-req-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Request
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/approved-property")}
              >
                <h4
                  className={`${splitLocation[1] === "approved-property" ||
                    splitLocation[1] === "property-approve-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Approved
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/rejected-property")}
              >
                <h4
                  className={`${splitLocation[1] === "rejected-property" ||
                    splitLocation[1] === "property-rej-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Rejected
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/property-reverification")}
              >
                <h4
                  className={`${splitLocation[1] === "property-reverification" ||
                    splitLocation[1] === "property-reverification-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Reverification
                  </span>
                </h4>
              </li>
            </ul>

            {/* Masters Nav Link */}
            {rolePermissions?.includes("CAN-LIST-MASTER") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => toggleMasters()}
              >
                <h4
                  className={`${[
                    "amenities",
                    "room-category",
                    "banners",
                    "add-banners",
                    "property-content",
                    "view-property-content",
                    "minimum-age",
                    "default-banner",
                    "location",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      [
                        "amenities",
                        "room-category",
                        "banners",
                        "add-banners",
                        "property-content",
                        "view-property-content",
                        "minimum-age",
                        "default-banner",
                        "location",
                      ].includes(splitLocation[1])
                        ? master_active
                        : master_img
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"

                  // onMouseEnter={() => setShowMasters(true)}
                  // onMouseLeave={() => setShowMasters(false)}
                  >
                    Masters <KeyboardArrowDownIcon />
                  </span>
                </h4>
              </li>
            )}
            {/* Masters Sub-Links */}
            <ul className={`sub-menu  ${showMasters ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/amenities")}
              >
                <h4
                  className={`${splitLocation[1] === "amenities" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Amenities
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/room-category")}
              >
                <h4
                  className={`${splitLocation[1] === "room-category" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Room Category
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/banners")}
              >
                <h4
                  className={`${splitLocation[1] === "banners" ||
                    splitLocation[1] === "add-banners"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Banners
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/property-content")}
              >
                <h4
                  className={`${splitLocation[1] === "property-content" ||
                    splitLocation[1] === "view-property-content"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Property Content
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/minimum-age")}
              >
                <h4
                  className={`${splitLocation[1] === "minimum-age" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Minimum Age
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/default-banner")}
              >
                <h4
                  className={`${splitLocation[1] === "default-banner" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Default Banner
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/location");
                }}
              >
                <h4
                  className={`${splitLocation[1] === "location" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  {/* {splitLocation[1] === "location" ? (
                    <img src={navi_active} className="icon" alt="" />
                  ) : (
                    <img src={navi_img} className="icon" alt="" />
                  )} */}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Location
                  </span>
                </h4>
              </li>
            </ul>

            {/* Blocked Nav Link */}
            {rolePermissions?.includes("CAN-LIST-BLOCKED") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => toggleBlocked()}
              >
                <h4
                  className={`${["property-unblock", "room-unblock"].includes(
                    splitLocation[1]
                  )
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      ["property-unblock", "room-unblock"].includes(
                        splitLocation[1]
                      )
                        ? booked_side
                        : booked_side_active
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"

                  // onMouseEnter={() => setShowMasters(true)}
                  // onMouseLeave={() => setShowMasters(false)}
                  >
                    Blocked <KeyboardArrowDownIcon />
                  </span>
                </h4>
              </li>
            )}
            {/* Blocked Sub-Links */}
            <ul className={`sub-menu  ${showBlocked ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/property-unblock")}
              >
                <h4
                  className={`${splitLocation[1] === "property-unblock"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Property Blocked
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/room-unblock")}
              >
                <h4
                  className={`${splitLocation[1] === "room-unblock" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Room Blocked
                  </span>
                </h4>
              </li>
            </ul>
            {rolePermissions?.includes("CAN-LIST-MMC") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => toggleMMC()}
              // onMouseLeave={() => setShowReviews(false)}
              >
                <h4
                  className={`${[
                    "transaction-list",
                    "suspended",
                    "suspended-view",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      ["transaction-list", "suspended"].includes(
                        splitLocation[1]
                      )
                        ? mmc_img
                        : mmc_active
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"
                  // onMouseEnter={() => setShowMmc(true)}
                  // onMouseLeave={() => setShowMmc(false)}
                  >
                    MMC <KeyboardArrowDownIcon />
                    {["transaction-list", "suspended"].includes(
                      splitLocation[1]
                    )}
                  </span>
                </h4>
              </li>
            )}
            <ul className={`sub-menu  ${showMmc ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/transaction-list")}
              >
                <h4
                  className={`${splitLocation[1] === "transaction-list"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Transaction List
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/suspended")}
              >
                <h4
                  className={`${splitLocation[1] === "suspended" ||
                    splitLocation[1] === "suspended-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Suspended
                  </span>
                </h4>
              </li>
            </ul>
            {rolePermissions?.includes("CAN-LIST-MMC CANCELLATION") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => toggleMmcCancellation()}
              // onMouseLeave={() => setShowReviews(false)}
              >
                <h4
                  className={`${[
                    "request",
                    "approved",
                    "rejected",
                    "mmc-req-view",
                    "mmc-appr-view",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      [
                        "request",
                        "approved",
                        "rejected",
                        "mmc-req-view",
                        "mmc-appr-view",
                      ].includes(splitLocation[1])
                        ? mmc_img
                        : mmc_active
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"
                  // onMouseEnter={() => setShowMmc(true)}
                  // onMouseLeave={() => setShowMmc(false)}
                  >
                    MMC Cancellation <KeyboardArrowDownIcon />
                    {[
                      "request",
                      "approved",
                      "rejected",
                      "mmc-req-view",
                      "mmc-appr-view",
                    ].includes(splitLocation[1])}
                  </span>
                </h4>
              </li>
            )}
            <ul className={`sub-menu  ${showMmcCancellation ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/request")}
              >
                <h4
                  className={`${splitLocation[1] === "request" ||
                    splitLocation[1] === "mmc-req-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Request
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/approved")}
              >
                <h4
                  className={`${splitLocation[1] === "approved" ||
                    splitLocation[1] === "mmc-appr-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Approved
                  </span>
                </h4>
              </li>
              {/* <li
                className="nav_link trans"
                onClick={() => navigate("/rejected")}
              >
                <h4
                  className={`${splitLocation[1] === "rejected" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Rejected
                  </span>
                </h4>
              </li> */}
            </ul>
            {rolePermissions?.includes("CAN-LIST-SUSPENDED PROPERTY") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => {
                  toggleSuspended();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "suspended-property" ||
                    splitLocation[1] === "suspended-property-view" ||
                    splitLocation[1] === "admin-suspended-property" ||
                    splitLocation[1] === "admin-suspended-view"
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "suspended-property" ||
                    splitLocation[1] === "suspended-property-view" ? (
                    <img src={navi_active} className="icon" alt="" />
                  ) : (
                    <img src={navi_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Suspended Property <KeyboardArrowDownIcon />
                  </span>
                </h4>
              </li>
            )}
            <ul className={`sub-menu  ${showSuspended ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/suspended-property")}
              >
                <h4
                  className={`${splitLocation[1] === "suspended-property" ||
                    splitLocation[1] === "suspended-property-view"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Review Suspended
                  </span>
                </h4>
              </li>
              {/* <li
                className="nav_link trans"
                onClick={() => navigate("/admin-suspended-property")}
              >
                <h4
                  className={`${splitLocation[1] === "admin-suspended-property" || splitLocation[1] === "admin-suspended-view"? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Admin Suspended
                  </span>
                </h4>
              </li> */}
            </ul>

            {/* Review Nav Link */}
            {rolePermissions?.includes("CAN-LIST-REVIEWS") && (
              <li
                className="nav_link trans mb-0"
                onClick={() => toggleReview()}
              // onMouseLeave={() => setShowReviews(false)}
              >
                <h4
                  className={`${[
                    "owner-review",
                    "user-review",
                    "receptionist-review",
                    "review",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar mb-0"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  <img
                    src={
                      [
                        "owner-review",
                        "user-review",
                        "receptionist-review",
                        "review",
                      ].includes(splitLocation[1])
                        ? navi_review
                        : navi_review_active
                    }
                    className="icon"
                    alt=""
                  />
                  <span
                    className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1 d-flex ac-jb w-100"
                  // onMouseEnter={() => setShowReviews(true)}
                  // onMouseLeave={() => setShowReviews(false)}
                  >
                    Review <KeyboardArrowDownIcon />
                    {[
                      "owner-review",
                      "user-review",
                      "receptionist-review",
                      "review",
                    ].includes(splitLocation[1])}
                  </span>
                </h4>
              </li>
            )}
            {/* Review Sub-Links */}
            <ul className={`sub-menu  ${showReviews ? "show" : ""}`}>
              <li
                className="nav_link trans"
                onClick={() => navigate("/user-review")}
              >
                <h4
                  className={`${splitLocation[1] === "user-review" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    User
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/owner-review")}
              >
                <h4
                  className={`${splitLocation[1] === "owner-review" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Owner
                  </span>
                </h4>
              </li>
              <li
                className="nav_link trans"
                onClick={() => navigate("/receptionist-review")}
              >
                <h4
                  className={`${splitLocation[1] === "receptionist-review"
                    ? "f3 active_bar"
                    : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 sub-dropdown`}
                >
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Receptionist
                  </span>
                </h4>
              </li>
            </ul>
            {rolePermissions?.includes("CAN-LIST-NOTIFICATION") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/notification");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "notification" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "notification" ? (
                    <img src={navi_active} className="icon" alt="" />
                  ) : (
                    <img src={navi_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Notification
                  </span>
                </h4>
              </li>
            )}

            <li
              className="nav_link trans"
              onClick={() => {
                navigate("/chat-list");
                onClose();
              }}
            >
              <h4
                className={`${splitLocation[1] === "chat-list" ? "f3 active_bar" : ""
                  } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
              >
                {splitLocation[1] === "chat-list" ? (
                  <img src={chat_icon} className="icon" alt="" />
                ) : (
                  <img src={chat_unselect} className="icon" alt="" />
                )}
                <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                  Chat Count
                </span>
              </h4>
            </li>
            {rolePermissions?.includes("CAN-VIEW-SALES") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/sales");
                  onClose();
                }}
              >
                <h4
                  className={`${splitLocation[1] === "sales" ? "f3 active_bar" : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16`}
                >
                  {splitLocation[1] === "sales" ? (
                    <img src={navi_active} className="icon" alt="" />
                  ) : (
                    <img src={navi_img} className="icon" alt="" />
                  )}
                  <span className="text text-nowrap f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 ps-1">
                    Sales
                  </span>
                </h4>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div
        className="d-flex ac-je pt-2 pe-2 pointer"
        onClick={() => setPopup(true)}
      >
        <img src={logout_icon} className="icon" alt="" />
        <h4 className="f2 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 mb-0">
          Logout
        </h4>
      </div>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mt-4">
              Logout
            </h2>
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  logout();
                }}
                className="yes-btn f2"
              >
                {loading ? "Loading..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileNavBar;
